import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/configs/store';
import useIsMobile from 'src/hooks/useIsMobile';
import _ from 'lodash';
import { format } from 'date-fns';
import Category from 'src/components/HorseBetting/Category/Category';
import LobbyInformation from 'src/components/HorseBetting/LobbyInformation/LobbyInformation';

function RacingSearch() {
  const { filterResults } = useSelector((state: RootState) => state.filters);
  const { searchResults } = useSelector((state: RootState) => state.events);

  const mobile = useIsMobile();

  let currentEvents = searchResults.list;
  if (mobile && filterResults.length > 0) {
    currentEvents = filterResults;
  }

  return (
    <div className="horse-betting__categories">
      <LobbyInformation />
      {
        _.size(currentEvents) > 0 &&
        _.map(Object.keys(currentEvents), (date:number, index) => {
          return (
            <div key={ index } className="search-results__date">{ format(new Date(+date * 1000), 'do LLLL yyyy') }
              {
                _.map(Object.keys(currentEvents[date]), (country) => {
                  const newTournaments = [];
                  const parsed = (JSON.parse(JSON.stringify(_.uniqBy(currentEvents[date][country], 'code'))));

                  for (const tournament of parsed){
                    for (const event of tournament.events){
                      event.eventStart = event.scheduled;
                      event.statusCode= 1;
                      event.status= event.raceInfos.status;
                      event.raceNo= event.raceInfos.no;
                    }

                    newTournaments.push({
                      name: tournament.name,
                      countryCode: country,
                      country: tournament.country,
                      eventStart: new Date(),
                      code: tournament.sportCode,
                      meetingInfos: tournament.meetingInfos,
                      events: tournament.events
                    });
                  }

                  return <Category key={ newTournaments[0].code + index } tournaments={ newTournaments } isSearch />;
                })
              }
            </div>
          );
        })
      }
    </div>
  );
}

export default RacingSearch;
